import { TransactionDetails } from 'store/transactions/types';

export const sortUpcomingBookingsByDate = (
  transactions: Array<TransactionDetails>,
): Array<TransactionDetails> | null => {
  if (!transactions) return null;
  return transactions.sort((a, b) => new Date(a.details?.start_at).getTime() - new Date(b.details?.start_at).getTime());
};
